var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/no-use-before-define */
import pluralize from 'pluralize';
import { minsToHours } from '../../utils';
var adaptGroupsActivityStreamToClient = function (_a) {
    var reports = _a.report;
    var groups = reports.map(function (report) {
        var _a = parseGroupData(report), title = _a.title, summary = _a.summary;
        var updatedStudents = report.students.map(function (student) {
            return __assign(__assign({}, student), { exercisesPercent: student.exercisesCompleted === 0
                    ? 0
                    : Math.round((student.exercisesCompletedSucc * 100) /
                        student.exercisesCompleted), exercisesCompletedSuccessfully: student.exercisesCompletedSucc });
        });
        var group = {
            title: title,
            summary: summary,
            students: updatedStudents,
            startDate: report.startDate,
            endDate: report.endDate,
        };
        return group;
    });
    return { groups: groups };
};
var parseGroupData = function (group) {
    var title = '';
    var summary = '';
    var _a = minsToHours(group.timeSpent), mins = _a.mins, hours = _a.hours;
    var hoursText = hours ? " " + hours + " h" : '';
    var minsText = '';
    if (mins)
        minsText = " " + mins + " min";
    else
        minsText = hours ? '' : ' < 1 min';
    title = group.title;
    summary = group.activeStudents + " active " + pluralize('students', group.activeStudents) + ", " + pluralize('task', group.tasksCompleted, true) + " solved," + hoursText + minsText + " spent";
    return { title: title, summary: summary };
};
export { adaptGroupsActivityStreamToClient };
